import { render, staticRenderFns } from "./TheThgPartnerList.vue?vue&type=template&id=cd5efeb0&scoped=true"
import script from "./TheThgPartnerList.vue?vue&type=script&lang=ts"
export * from "./TheThgPartnerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5efeb0",
  null
  
)

export default component.exports